import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { checkPermission } from "../../app/utils/helpers";
import { showSuccessToast, showErrorToast } from "../../app/utils/helpers";
import { config } from "../../app/utils/config";
import {
  setUpdatePermissionsRes,
  setSelectedView,
  getAllContracts,
  getAllCollabs,
  getAllMissionReviews,
} from "../../components/collabs/collabsSlice";
import { getAllMissions } from "../../components/teams/teamsSlice";

export function useContractsData(viewsOptions) {
  const dispatch = useDispatch();
  const urlParams = useParams();
  const mounted = useRef(null);

  const permissionsMessage = useSelector(
    (state) => state.collabs.updatePermissionsRes
  );
  const permissions = useSelector((state) => state.login.permissions);

  // Set default view on mount when user has permission
  useEffect(() => {
    if (
      checkPermission(config.scopes.collabs, config.permissionTypes.view)
    ) {
      dispatch(setSelectedView(0));
    }
  }, [mounted, permissions]);

  // Sync view from URL params
  useEffect(() => {
    if (urlParams.subView && viewsOptions[urlParams.subView]) {
      dispatch(setSelectedView(urlParams.subView));
    }
  }, [urlParams]);

  // Fetch all data on mount
  useEffect(() => {
    if (!mounted.current) {
      if (
        checkPermission(config.scopes.collabs, config.permissionTypes.view)
      ) {
        dispatch(getAllCollabs());
        dispatch(getAllContracts());
        dispatch(getAllMissions());
        dispatch(getAllMissionReviews());
      }
      mounted.current = true;
    }
  }, [dispatch]);

  // Show toast on permission update result
  useEffect(() => {
    if (permissionsMessage != null) {
      if (
        permissionsMessage.trim().toLowerCase().includes("successfully")
      ) {
        showSuccessToast(permissionsMessage);
      } else {
        showErrorToast(permissionsMessage);
      }
      dispatch(setUpdatePermissionsRes());
    }
  }, [permissionsMessage]);
}
